export default __webpack_public_path__ + "static/media/whirlwind4.4a683f81.png";